import * as React from 'react';

const ZoomMinusIcon = () => (
  <svg
    xmlns='http://www.w3.org/2000/svg'
    width='24'
    height='24'
    viewBox='0 0 24 24'
    fill='none'
  >
    <g clipPath='url(#clip0_10066_2882)'>
      <path
        d='M2.83179 13.2938L22 13.2938L21.1682 10.7061L2 10.7061L2.83179 13.2938Z'
        fill='#695f5f'
      />
    </g>
    <defs>
      <clipPath id='clip0_10066_2882'>
        <rect width='24' height='24' fill='#695f5f' />
      </clipPath>
    </defs>
  </svg>
);

export default ZoomMinusIcon;
